import { MessageCircle, Ruler } from "lucide-react";
import { SIZE_CHART, waLink } from "@/lib/content";

const FIT_NOTES = [
  ["Straight Kurtis", "Tailored through the body. True to size – size up for a relaxed look."],
  ["Anarkali Suits", "Fitted bodice, flared skirt. Between sizes? Choose the larger for bust comfort."],
  ["Relaxed Cotton Kurtis", "Easy A-line fit with ease built in. Pick your regular size or size down for a closer fit."],
];
const STEPS = [
  ["Bust", "Measure around the fullest part of your bust, keeping the tape level."],
  ["Waist", "Measure around your natural waistline, the narrowest part of your torso."],
  ["Hip", "Measure around the fullest part of your hips, feet together."],
  ["Kurta Length", "From the highest point of the shoulder down to where you want the hem."],
];

export const SizeTable = () => (
  <div className="overflow-x-auto rounded-2xl border border-[#E7E2DB] bg-white">
    <table data-testid="size-guide-table" className="w-full min-w-[420px] text-center text-sm">
      <thead className="bg-[#F4EFEA] text-[11px] uppercase tracking-[0.15em] text-[#57534E]">
        <tr>{["Size", "Bust", "Waist", "Hip", "Kurta Length"].map((h) => <th key={h} className="px-3 py-3 font-semibold">{h}</th>)}</tr>
      </thead>
      <tbody>
        {SIZE_CHART.map((r) => (
          <tr key={r[0]} className="border-t border-[#E7E2DB] transition-colors hover:bg-[#FAF7F2]">
            <td className="px-3 py-3 font-semibold text-[#701A24]">{r[0]}</td>
            {r.slice(1).map((v, i) => <td key={i} className="px-3 py-3 text-[#44403C]">{v}"</td>)}
          </tr>
        ))}
      </tbody>
    </table>
    <p className="px-4 py-2 text-left text-[11px] text-[#78716C]">All measurements are body measurements in inches. Kurta length shown for straight & cotton kurtis; Anarkali length is ~52".</p>
  </div>
);

export const FitNotes = () => (
  <div className="grid gap-3">
    {FIT_NOTES.map(([t, d]) => (
      <div key={t} className="rounded-2xl border border-[#E7E2DB] bg-white p-4">
        <p className="font-serif-display text-lg font-semibold text-[#1B4332]">{t}</p>
        <p className="mt-1 text-sm text-[#57534E]">{d}</p>
      </div>
    ))}
  </div>
);

export default function SizeGuideSection() {
  return (
    <section id="size-guide" data-testid="size-guide-section" className="kt-container py-16 sm:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">Find your fit</p>
          <h2 className="mt-3 font-serif-display text-4xl font-semibold leading-tight sm:text-5xl">The Kurtaani <em className="text-[#B85D43]">Size Guide</em></h2>
          <ol className="mt-8 space-y-5">
            {STEPS.map(([t, d], i) => (
              <li key={t} className="flex gap-4">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#EAE0D5] font-serif-display text-lg text-[#701A24]">{i + 1}</span>
                <div><p className="text-sm font-semibold">{t}</p><p className="text-sm text-[#57534E]">{d}</p></div>
              </li>
            ))}
          </ol>
        </div>
        <div className="space-y-6 lg:col-span-8">
          <SizeTable />
          <FitNotes />
          <div className="flex flex-col items-start gap-4 rounded-2xl bg-[#1B4332] p-6 text-[#FAF7F2] sm:flex-row sm:items-center sm:justify-between">
            <p className="flex items-center gap-3 font-serif-display text-xl"><Ruler className="h-5 w-5 text-[#D99B8E]" /> Not sure about your size?</p>
            <a data-testid="size-guide-whatsapp-button" href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white hover:bg-[#20ba5a]">
              <MessageCircle className="h-4 w-4" /> WhatsApp us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
